"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditEntity = EditEntity;
const Form_1 = require("@juvare/common-form-ui/Form");
const AppPage_1 = require("@juvare/common-web-ui/AppPage");
const AppPageHeader2_1 = require("@juvare/common-web-ui/AppPageHeader2");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const PageError_1 = require("@juvare/common-web-ui/PageError");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const classifiers_1 = require("../../../../../../ui/features/classifiers");
const hooks_1 = require("../../../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
function EditEntity(props) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const { id } = (0, react_router_1.useParams)();
    const storage = (0, hooks_1.useStorageClient)(props.entity);
    const { data, isLoading, error } = (0, hooks_1.useStorageGet)(props.entity, id);
    const defaultFormConfig = (0, classifiers_1.useDefaultFormConfig)();
    if (error) {
        return react_1.default.createElement(PageError_1.PageError, { error: error });
    }
    if (isLoading || !data) {
        return react_1.default.createElement(material_1.CircularProgress, null);
    }
    return (react_1.default.createElement(AppPage_1.AppPage, { header: react_1.default.createElement(AppPageHeader2_1.AppPageHeader2, { title: props.title, subTitle: props.getEntityTitle(data), onBack: () => navigationContext.navigate(() => (location.state?.back ? navigate(-1) : navigate('..'))) }), contentWidth: props.formWidth ?? 800, contentScrollable: true, contentPadding: 2 },
        react_1.default.createElement(Form_1.Form, { config: props.formConfig ?? defaultFormConfig, data: data.data, submitLabel: t('common.save'), trackChanges: 'ask-to-save', onSubmit: (newData) => {
                if (props.partialUpdate) {
                    return storage.post({
                        action: 'partial-update',
                        id: data.id,
                        parentId: data.parentId,
                        data: newData,
                    });
                }
                else {
                    return storage.post({
                        action: 'update',
                        id: data.id,
                        parentId: data.parentId,
                        data: newData,
                    });
                }
            }, onSubmitSuccess: () => {
                (0, SnackbarHelper_1.showInfoSnackbar)({ message: t('common.itemSaved', { item: props.title }) });
                if (location.state?.back) {
                    navigate(-1);
                }
                else {
                    navigate({
                        pathname: '..',
                        search: new URLSearchParams({ id: data.id }).toString(),
                    }, {});
                }
            } })));
}
